import { type PlanType } from 'constants/plan-type';

export const ONBOARDING_AB_TEST_PROJECT = 'onboarding-ab-test' as const;
export const ONBOARDING_AB_TEST_TYPE = 'ab_test' as const;
export const ONBOARDING_AB_TEST_EXPERIMENT = 'onboarding-ab-test-install-code-step' as const;
interface GenericEventCollectorEvent<P extends string, T extends string> {
  project: P;
  type: T;
  request_id: string;
  template_version: string;
}

export interface AnswerUsageEvent extends GenericEventCollectorEvent<'knowledge-buddy', 'answer_usage'> {
  data: {
    version: string;
    use_button_click: boolean;
    agent_response: string;
  };
}

interface TagSuggestionsDisplayedEvent
  extends GenericEventCollectorEvent<'tag_suggestions', 'displayed_tag_suggestions'> {
  data: {
    version: string;
    timestamp: number;
    license_id: string;
    thread_id: string;
    received_tags: string[];
    suggested_tags: string[];
    messages_timestamps: number[];
    model_version: string;
  };
}

interface TagSuggestionsSelectTagEvent extends GenericEventCollectorEvent<'tag_suggestions', 'selected_tags'> {
  data: {
    version: string;
    timestamp: number;
    license_id: string;
    thread_id: string;
    selected_tag: string;
    model_version: string;
    from_suggestion: boolean;
  };
}

export interface AIAssistantReplyFeedbackEvent extends GenericEventCollectorEvent<'live-assistant', 'feedback'> {
  data: {
    version: string;
    thumbsdown: boolean;
    negative_aspects: string[];
  };
}

export interface AutotagsEvent extends GenericEventCollectorEvent<'autotags', 'chat_autotagged'> {
  data: {
    version: string;
    plan_type: PlanType;
    is_trial: boolean;
    license_id: string;
    chat_id: string;
  };
}

export type TagSuggestionsEvent = TagSuggestionsDisplayedEvent | TagSuggestionsSelectTagEvent;

interface AICannedsDisplayedEvent extends GenericEventCollectorEvent<'cr_suggestions', 'displayed_cr_suggestions'> {
  data: {
    timestamp: number;
    license_id: string;
    thread_id: string;
    suggested_canneds: string[];
    model_version: string;
  };
}

interface AICannedsSelectedEvent extends GenericEventCollectorEvent<'cr_suggestions', 'selected_cr_suggestions'> {
  data: {
    timestamp: number;
    license_id: string;
    thread_id: string;
    selected_canned: string;
    model_version: string;
  };
}

interface InstallCodeEvent
  extends GenericEventCollectorEvent<typeof ONBOARDING_AB_TEST_PROJECT, typeof ONBOARDING_AB_TEST_TYPE> {
  data: {
    variant: string;
    experiment_name: string;
    unleash_data_checksum: string;
    used_count: number;
    used_configs: string[];
  };
}

export type AICannedsEvent = AICannedsDisplayedEvent | AICannedsSelectedEvent;

export type MLGatewaySendEvent =
  | AnswerUsageEvent
  | TagSuggestionsEvent
  | AIAssistantReplyFeedbackEvent
  | AutotagsEvent
  | AICannedsEvent
  | InstallCodeEvent;
